(function () {
  if (!document.body.classList.contains('template-cart')) return;

  const VAT_LABEL = 'Adószám';
  const OLD_LABELS = new Set([
    'cím 2',
    '2. cím',
    'address 2',
    'address line 2',
    'optional address2 label',
  ]);

  function normalizeLabel(value) {
    return (value || '').trim().toLowerCase();
  }

  function shouldRename(value) {
    const normalized = normalizeLabel(value);
    return OLD_LABELS.has(normalized) || normalized === 'cím 2.' || normalized === 'cim 2';
  }

  function renameVatLabels(root) {
    const scope = root || document;
    const candidates = scope.querySelectorAll(
      '.szb-vat-card__title, label, legend, .field__label, span, p, [aria-label], [placeholder]'
    );

    candidates.forEach((el) => {
      const text = (el.textContent || '').trim();
      if (shouldRename(text)) {
        el.textContent = VAT_LABEL;
      }

      const aria = el.getAttribute('aria-label');
      if (aria && shouldRename(aria)) {
        el.setAttribute('aria-label', VAT_LABEL);
      }

      const placeholder = el.getAttribute('placeholder');
      if (placeholder && shouldRename(placeholder)) {
        el.setAttribute('placeholder', '12345678-1-12');
      }
    });

    const vatTitle = scope.querySelector('.szb-vat-card__title');
    if (vatTitle && !vatTitle.textContent.trim()) {
      vatTitle.textContent = VAT_LABEL;
    }
  }

  function placeVatAfterShipping() {
    const shipping = document.querySelector('.peakship-app-block-container');
    const vatCard = document.querySelector('.szb-vat-card');
    if (!shipping || !vatCard) return false;

    const vatHost = vatCard.closest('.shopify-app-block') || vatCard.parentElement;
    if (!vatHost || (vatHost === shipping.parentElement && shipping.nextElementSibling === vatHost)) {
      return true;
    }

    shipping.insertAdjacentElement('afterend', vatHost);
    return true;
  }

  function init() {
    placeVatAfterShipping();
    renameVatLabels();
  }

  init();

  const observer = new MutationObserver(() => {
    init();
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  window.addEventListener('load', init);
})();
